<template>
  <tbody
    class="directory-order-table-row"
    :class="[index % 2 === 0 ? 'row-even' : 'row-odd']"
  >
    <template>
      <template v-for="(item) in displayItems">
        <template
          v-for="(company, mainCompanyIndex) in item.companies"
        >
          <tr
            :key="company.id"
            class="directory-row"
          >
            <td class="tenancyId">
              <a
                v-if="allowClickTenancyId"
                class="name-hyper-link"
                @click="clickTenancyId"
              >{{ mainCompanyIndex ? '' : item.tenancy.id }}</a>
              <span v-else>{{ mainCompanyIndex ? '' : item.tenancy.id }}</span>
            </td>
            <td class="tenantName">
              {{ item.tenancy.company.name }}
            </td>
            <td class="engName">
              <a
                v-if="allowClickCompanyName"
                class="name-hyper-link"
                @click="clickCompanyName"
              >{{ company.engName | isEmptyValue }}
              </a>
              <span v-else>{{ company.engName | isEmptyValue }}</span>
              <span
                v-if="!company.chsName && company.chtName && viewType === 'LOBBY'"
                class="no-cht-name"
              >{{ $t('directory.hint.chinese') }}</span>
            </td>
            <td class="chtName">
              {{ company.chtName | isEmptyValue }}
            </td>
            <td class="floor">
              {{ (isFloor ? (item.floor || $t('emptyValue')) : getFloorAndPremisesAtTerminal(company)) }}
            </td>
            <td
              class="premises"
              v-if="isFloor"
            >{{ company['premises'] | isEmptyValue }}</td>
            <td class="effectiveDate">{{ mainCompanyIndex ? '' : formatDate(item.effectiveDate) }}</td>
            <td
              class="status"
              v-show="!mainCompanyIndex"
              :class="`status--${getStatusClass(item)}`"
            >
              <span>{{ formatStatus(item.status, item.action) }}</span>
            </td>
            <td class="effectiveDate">{{ mainCompanyIndex ? '' : formatDate(item.removeDate) }}</td>
            <td class="effectiveDate">{{ mainCompanyIndex ? '' : formatDate(item.publishedAt) }}</td>
          </tr>
          <template v-for="subComp in company.subCompanies">
            <tr
              :key="subComp.id"
              class="sub-company directory-row"
            >
              <td class="tenancyId" />
              <td class="tenantName" />
              <td
                v-for="header in subDetailHeaders"
                :key="header"
                :class="header.cls"
              >{{
                 typeof header.attr === 'function'
                   ? header.attr(subComp)
                   : (subComp[header.attr] || $i18n.t('emptyValue'))
               }}
                <span
                  v-if="!subComp.chsName && header.attr === 'engName' && subComp.chtName && viewType === 'LOBBY'"
                  class="no-cht-name"
                >{{ $t('directory.hint.chinese') }}</span>
              </td>
              <td
                class="premises"
                v-if="isFloor"
              >{{ subComp['premises'] }}</td>
              <td colspan="8" />
            </tr>
            <tr
              :key="detail.id"
              v-for="detail in subComp.subDetails"
              class="sub-detail directory-row"
            >
              <td class="tenancyId" />
              <!-- there should be no premises info for level3/detail -->
              <td class="tenantName" />

              <td
                v-for="header in subDetailHeaders"
                :key="header"
                :class="header.cls"
              >{{
                typeof header.attr === 'function'
                  ? header.attr(detail)
                  : (detail[header.attr] || $i18n.t('emptyValue'))
              }}
              </td>
              <td
                class="premises"
                v-if="isFloor"
              />
              <td colspan="8" />
            </tr>
          </template>
        </template>
      </template>
    </template>
  </tbody>
</template>
<script>
import DirectoryOrderTableRow from './DirectoryOrderTableRow'
import dateUtil from '@/utils/dateUtil'
import { formatArchivedSearchStatus } from '@/modules/directories/utils'
import {DIR_STATUS} from '@/modules/directories/consts'

export default {
  name: 'DirectoryArchivedTableRow',

  mixins: [ DirectoryOrderTableRow ],
  methods: {
    formatDate (dateString, includeTime = false) {
      return dateString
        ? dateUtil.formatDate(dateString, includeTime)
        : this.$t('emptyValue')
    },
    formatStatus: formatArchivedSearchStatus,
    getStatusClass (item) {
      if (item.status === DIR_STATUS.PROCESSED) return DIR_STATUS.PROCESSED.toLowerCase()
      return formatArchivedSearchStatus(item.status, item.action).toLowerCase()
    },
  },
}
</script>
<style lang="scss" scoped>
@import "~styles/table";
@import "~styles/directories/maintain";
@import "~styles/directories/common";

.row-odd {
  tr {
    background-color: #fefefe !important;
  }
}
.row-even {
  tr {
    background-color: #f8f8f8 !important;
  }
}
.virtual-scroll-placeholder {
  td {
    text-align: center;
    padding: 0;
  }
}

.name-hyper-link {
  color: #1779ba;
}
</style>
